import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./App.css";
import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter /* basename="/" */>
      <Suspense fallback={<div>Loading…</div>}>
        <App />
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);
